'use strict';

const {degToRad} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('scale-example', function () {
    let triangleSideLength = this.width - this.pad * 2;
    let triangleHeight = Math.sin(degToRad(60)) * triangleSideLength;

    const heightPadding = (this.width - triangleHeight) / 2;

    const bigOrigin = new Point(this.pad + triangleSideLength, heightPadding + triangleHeight);
    let bigShape = new Shape(3, triangleSideLength, bigOrigin);

    let small = new Shape(3, triangleSideLength / 2, new Point(bigOrigin.x - (triangleSideLength * (1/4)), bigOrigin.y - triangleHeight / 2));

    const reset = () => {
        this.ctx.clearRect(0, 0, this.width, this.width);
        bigShape.draw(this.ctx);
        small.draw(this.ctx);
    };

    const demo = () => {
        reset();
        bigShape.silent = true;
        bigShape.tick(this.ctx);
        bigShape.tick(this.ctx);
        bigShape.tick(this.ctx);
        bigShape.tick(this.ctx);
        bigShape.tick(this.ctx);
        bigShape.silent = false;
        bigShape.dotSize = 2;
        let pointA = bigShape.tick(this.ctx);
        pointA.annotate(this.ctx, 'A', 0, 5);
        bigShape.getPointsForFractify = function () {
            return [this.points[1]];
        };
        bigShape.dotSize = 1;
        let pointB = bigShape.tick(this.ctx);
        pointB.annotate(this.ctx, 'B', 0, 5);
        bigShape.getPointsForFractify = Shape.prototype.getPointsForFractify;
    };

    this.node.querySelector('.demo').addEventListener('click', demo);

    demo();
});


